import { render, staticRenderFns } from "./bwleads.vue?vue&type=template&id=86561d62&"
import script from "./bwleads.vue?vue&type=script&lang=js&"
export * from "./bwleads.vue?vue&type=script&lang=js&"
import style0 from "./bwleads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports